import moment from 'moment';
import React from 'react';
import { FormattedDate } from 'react-intl';

function dueDateToClassName(inputDate: string) {
    const currentDate = moment(new Date());
    const dueDate = moment(inputDate);

    if (currentDate > dueDate) {
        return 'label-danger';
    }

    const diffInDays = moment(inputDate).diff(moment(currentDate), 'days');
    if (diffInDays < 7) {
        return 'label-warning';
    }
    return 'label-info';
}

export function WorkflowDueDateLabel(props: { value: string | null }) {
    if (!props.value) {
        return null;
    }

    return (
        <span className={`label ${dueDateToClassName(props.value)}`}>
            <FormattedDate value={props.value} year="numeric" month="short" day="numeric" />
        </span>
    );
}
